"use strict";
import {
    on,
    find,
    addClass,
    removeClass,
    hasClass,
    findAll,
    findAllIn,
    findIn,
    empty,
    setAttribute, toggleClass
} from '@elements/dom-utils';
import {cleanUpInScope, initInScope, onFind} from "@elements/init-modules-in-scope";
import axios from "axios";
import Dropdown from "bootstrap/js/dist/dropdown";

export function init () {
    onFind('.js-wishlist-dl', function (element) {
        let name = findAll(".js-wishlist-dl__checkbox");
        let footer = find('.js-wishlist-dl__footer');

        on('change', function () {
            let count = 0;
            let filenames = [];
            let ids = [];
            let wording = '';
            switch (document.documentElement.lang) {
                case 'de':
                    wording = 'ausgewählt';
                    break;
                case 'it':
                    wording = 'selezionati';
                    break;
                case 'fr':
                    wording = 'sélectionnés';
                    break;
                default:
                    wording = 'selected';
            }

            name.forEach(element => {
                let filename = element.parentNode.firstElementChild.innerHTML.replace(/\s+/g, '');
                let id = element.id;

                if(element.checked === true){
                    count ++;
                    filenames.push(filename);
                    ids.push(id);
                }
            });

            if(count >= 1){
                footer.hidden = false;
            }else {
                footer.hidden = true;
            }

            let fname = "";
            filenames.forEach(name => {
                if (name == filenames.slice(-1)){
                    fname += name
                }else{
                    fname += name + ",  "
                }
            })
            console.log(typeof lang);
            findIn(".js-wishlist-dl__footer-amount", footer).innerHTML = `${count} ${wording}`;
            findIn(".js-wishlist-dl__footer-names", footer).innerHTML = "( " + fname + " )";

            let form = find('.js-dl-modal__form');
            form.setAttribute('data-dl-modal-ids', Object.values(ids));
        }, element);
    });
}
